import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';


import Box from '@mui/material/Box';

import Moment from 'react-moment';

import {IEvent, IEventData, IPlace} from "../EventList/EventList";
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

export interface IRegisterButtonProps {
  place?: IPlace,
  event: IEvent,
  successCallback: () => void,
}

export interface IRegisterFormState {
  givenName?: string,
  familyName?: string,
  addressLine1?: string,
  postalCode?: string,
  locality?: string,
  mail?: string,
  newsletter?: boolean,
  meal?: boolean,
}



const RegisterButton = (props: IRegisterButtonProps) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [state, setState] = React.useState<IRegisterFormState>({
    givenName:  '',
    familyName:  '',
    addressLine1:  '',
    postalCode:  '',
    locality:  '',
    mail:  '',
    newsletter: false,
    meal: false,
  });
  const [error, setError] = React.useState<IRegisterFormState>({
    givenName:  '',
    familyName:  '',
    addressLine1:  '',
    postalCode:  '',
    locality:  '',
    mail:  '',
    newsletter: false,
    meal: false,
  });



  const handleClickOpen = () => {
    setError({
      givenName:  '',
      familyName:  '',
      addressLine1:  '',
      postalCode:  '',
      locality:  '',
      mail:  '',
      newsletter: false,
      meal: false,
    });
    setLoading(false);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    if(validate()) {
      setLoading(true);
      const data = {...state, uuidEvent : props.event.uuid, uuidPlace : props?.place?.uuid};

      // send a POST request
      var getUrl = window.location;
      var baseURL = getUrl .protocol + "//" + getUrl.host;
      if (baseURL == 'http://localhost:3000') {
        baseURL = 'https://buxliest.local.computer';
      }
      axios(baseURL + "/bux-api/bux-event/add-attendee?_format=json", {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'post',
        data: data
      }).then((response) => {
        props.successCallback();
        setState({
          givenName:  '',
          familyName:  '',
          addressLine1:  '',
          postalCode:  '',
          locality:  '',
          mail:  '',
          newsletter: false,
          meal: false,
        });
        setLoading(false);
        setOpen(false);
      }, (error) => {
        console.log(error);
      });
    }

  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const changed = { [event.target.name]: event.target.value };
    const newState = {...state, [event.target.name] : event.target.value};
    setState(newState);
  }

  const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    const changed = { [event.target.name]: event.target.checked };
    const newState = {...state, [event.target.name] : event.target.checked};
    setState(newState);
  }

  const validate = () => {
    let temp = { } as IRegisterFormState;

    temp.givenName = state.givenName ? "" : "Das Feld darf nicht leer sein."
    temp.familyName = state.familyName ? "" : "Das Feld darf nicht leer sein."
    temp.mail = state.mail ? "" : "Das Feld darf nicht leer sein."

    setError(temp);

    return Object.values(temp).every(x => x == "")
  }


  return (
    <>
      {props.event.seatsAvailable > 0 &&
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        Anmelden
      </Button>
      }
      {props.event.seatsAvailable <= 0 &&
        <>
        <Button variant="contained" color="primary" disabled onClick={handleClickOpen}>
          Anmelden
        </Button>
        <Button variant="contained" color="primary" onClick={handleClickOpen} className="ml-8">
          Warteliste
        </Button>
        </>
      }

      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Anmelden</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            <Moment format="HH:mm U\hr" parse="YYYY-MM-DDTHH:mm:ss">
              {props.event.starts}
            </Moment>
            <Box>{props.event.title}</Box>
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            name="givenName"
            label="Vorname"
            type="text"
            variant="filled"
            fullWidth
            required
            value={state.givenName}
            onChange={handleChange}
            {...(error.givenName && {error:true,helperText:error.givenName})}
          />
          <TextField
            margin="dense"
            name="familyName"
            label="Nachname"
            type="text"
            variant="filled"
            fullWidth
            required
            value={state.familyName}
            onChange={handleChange}
            {...(error.familyName && {error:true,helperText:error.familyName})}
          />
          <TextField
            margin="dense"
            name="mail"
            label="E-Mail"
            type="email"
            variant="filled"
            fullWidth
            required
            value={state.mail}
            onChange={handleChange}
            {...(error.mail && {error:true,helperText:error.mail})}
          />

          {(props.event.title.indexOf("Sunrise on the reaping") > -1 || props.event.title.indexOf("Heinz Erhardt") > -1) && (
            <FormControlLabel
              control={
                <Checkbox
                  name="meal"
                  checked={state.meal}
                  onChange={handleChangeCheckbox}
                />
              }
              label='Ich möchte das Angebot von "Butterbrot & Blattgold" wahrnehmen und bestelle hiermit einmal Fingerfood und ein Glas Wein.'
              sx={{
                mt: '10px',
                '& .MuiFormControlLabel-label': {
                  color: 'gray',
                  fontSie: '16px',
                },
              }}
            />
          )}

          <FormControlLabel control={
              <Checkbox
                name="newsletter"
                checked={state.newsletter}
                onChange={handleChangeCheckbox}
              />
            }
            label="Ich möchte über Neuigkeiten zu Buxtehude Liest informiert werden. Die Zustimmung kann jederzeit widerrufen werden."
            sx={{
              mt: '10px',
              '& .MuiFormControlLabel-label': {
                color: 'gray',
                fontSie: '16px',
              },
            }}
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Abbrechen
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained" disabled={loading}>
            Anmelden
          </Button>
        </DialogActions>
      </Dialog>
    </>


  );
}


export default RegisterButton;

